import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class HideCondition extends PrimitiveValueObject<boolean> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: boolean): HideCondition {
    return new HideCondition(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '機嫌を表示しない';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {};
  }

  /**
   * キー
   */
  static get key(): string {
    return 'hideCondition';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'boolean';
  }
}
